export const getFormattedDate = (currentDate) => {
  // Get the year, month, and day from the date object
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  // Format the date as "YYYY-MM-DD"
  return `${year}-${month}-${day}`;
};
